export default __webpack_public_path__ + "static/media/searpent_headline_white.cf565dc3.png";